// Returns a debounced copy of `value` that only updates after `delayMs` of
// quiet — the last write within a burst wins. Handy for search inputs that
// drive a server query without firing a request per keystroke.

import { useEffect, useState } from 'react';

export default function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);
  return debounced;
}
